import { useCallback, useState } from 'react'
import { AnimatePresence, motion, Variants } from 'framer-motion'

import SvgEmoji from '@/src/assets/icons/Emoji'

import { Reactions } from '../Reactions/Reactions'

import { useAppSelector } from '@/src/store/hooks'
import { selectBranding } from '@/src/store/slices/meetData'

import styles from './ReactionToggle.module.css'

const buttonVariants: Variants = {
  tap: { scale: 0.9 },
}

interface IReactionToggleProps {
  isPiP?: boolean
}

export const ReactionToggle = ({ isPiP }: IReactionToggleProps) => {
  const { text_primary_color } = useAppSelector(selectBranding)

  const [isShowPopover, setIsShowPopover] = useState<boolean>(false)

  const handleTogglePopover = useCallback(() => {
    setIsShowPopover((prev) => !prev)
  }, [])

  const handleHidePopover = useCallback(() => {
    setIsShowPopover(false)
  }, [])

  return (
    <div className={styles?.container}>
      <AnimatePresence>
        {isShowPopover && <Reactions closePopover={handleHidePopover} isPiP={isPiP} />}
      </AnimatePresence>

      <motion.button
        className={styles?.button}
        onClick={handleTogglePopover}
        variants={buttonVariants}
        whileTap="tap"
      >
        <SvgEmoji style={{ fill: text_primary_color ?? '#fff' }} />
      </motion.button>
    </div>
  )
}
